import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Drawer, AppBar, Toolbar, List, Typography, Divider, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, Button, } from '@mui/material';
import { Menu as MenuIcon, Dashboard as DashboardIcon, Agriculture as MachineIcon, Settings as SettingsIcon, Logout as LogoutIcon, } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
const drawerWidth = 240;
const Layout = ({ children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { user, logout, isAdmin } = useAuth();
    const navigate = useNavigate();
    // Debug log to check user admin status
    console.log('Layout - User:', user, 'IsAdmin:', isAdmin);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const handleLogout = () => {
        logout();
        navigate('/login');
    };
    const menuItems = [
        { text: 'Dashboard', icon: _jsx(DashboardIcon, {}), path: '/dashboard' },
        { text: 'Machines', icon: _jsx(MachineIcon, {}), path: '/machines' },
        { text: 'Admin', icon: _jsx(SettingsIcon, {}), path: '/admin', adminOnly: true },
    ];
    const drawer = (_jsxs("div", { children: [_jsx(Toolbar, { children: _jsx(Typography, { variant: "h6", noWrap: true, children: "Hubbard's" }) }), _jsx(Divider, {}), _jsx(List, { children: menuItems
                    .filter((item) => !item.adminOnly || isAdmin)
                    .map((item) => (_jsx(ListItem, { disablePadding: true, children: _jsxs(ListItemButton, { onClick: () => navigate(item.path), children: [_jsx(ListItemIcon, { children: item.icon }), _jsx(ListItemText, { primary: item.text })] }) }, item.text))) })] }));
    return (_jsxs(Box, { sx: { display: 'flex' }, children: [_jsx(AppBar, { position: "fixed", sx: {
                    width: '100%',
                    backgroundImage: 'url(/tractor.png)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    backgroundBlendMode: 'overlay',
                }, children: _jsxs(Toolbar, { children: [_jsx(IconButton, { color: "inherit", edge: "start", onClick: handleDrawerToggle, sx: { mr: 2 }, children: _jsx(MenuIcon, {}) }), _jsx(Typography, { variant: "h6", noWrap: true, component: "div", sx: { flexGrow: 1, textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }, children: "Hubbard's Contracting" }), _jsxs(Typography, { variant: "body1", sx: { display: { xs: 'none', sm: 'block' }, mr: 2, textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }, children: [user === null || user === void 0 ? void 0 : user.firstName, " ", user === null || user === void 0 ? void 0 : user.lastName] }), _jsx(Button, { color: "inherit", onClick: handleLogout, startIcon: _jsx(LogoutIcon, {}), children: "Logout" })] }) }), _jsx(Box, { component: "nav", children: _jsx(Drawer, { variant: "temporary", open: mobileOpen, onClose: handleDrawerToggle, ModalProps: { keepMounted: true }, sx: {
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }, children: drawer }) }), _jsxs(Box, { component: "main", sx: {
                    flexGrow: 1,
                    p: 3,
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                }, children: [_jsx(Toolbar, {}), children] })] }));
};
export default Layout;
'100%';
